

const TitleDescriptionPopup = (props) => {
    const text = props.text
    const style = props.style

    return(
        <div className="title-description-popup-container" style={style}>
            <div className="page-title-hover-triangle-outer">
                <div className="page-title-hover-triangle-inner"/>
            </div>
            {text && text.map((line, idx) => {
                return(
                    <div className="title-description-popup-text" key={idx}>{line}</div>
                )
            })}

        </div>
    )
}

export default TitleDescriptionPopup